const meta = {
  monitoring: 'Monitoring',
  sso: 'Single sign-on',
};

export default meta;
